import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { usePaymentMode } from '@/contexts/PaymentModeContext';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Clock, Sparkles } from 'lucide-react';

export const TrialExpiredModal = () => {
  const { user } = useAuth();
  const paymentMode = usePaymentMode();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Only show modal if payment mode is enabled AND trial expired
    if (paymentMode.enabled && user && user.is_trial && user.time_remaining_seconds <= 0 && !user.trial_extended) {
      setShowModal(true);
    }
  }, [user, paymentMode.enabled]);

  // Don't render anything if payment mode is disabled
  if (!paymentMode.enabled) {
    return null;
  }

  const handleSubscribe = () => {
    setShowModal(false);
    navigate('/compte');
  };

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="bg-bg-secondary border-white/10 max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="text-center mb-4">
            <button 
              onClick={() => { setShowModal(false); navigate('/'); }}
              className="inline-block hover:opacity-80 transition-opacity"
            >
              <h1 className="font-bebas text-5xl text-netflix-red mb-4">WEBEOS</h1>
            </button>
            <DialogTitle className="text-3xl font-bebas text-white mb-2">
              ESSAI GRATUIT TERMINE !
            </DialogTitle>
            <DialogDescription className="text-text-secondary font-inter text-base">
              Vous avez profite de 15 minutes de streaming gratuit
            </DialogDescription>
          </div>
        </DialogHeader>
        
        <div className="space-y-6">
          <div className="p-6 bg-gradient-to-r from-purple-900/30 to-pink-900/30 border border-purple-500/30 rounded-lg text-center">
            <h3 className="font-bebas text-2xl text-white mb-3">
              Maintenant que vous nous faites confiance...
            </h3>
            <p className="text-text-secondary font-inter mb-4">
              N'hesitez pas a vous abonner pour profiter de tous nos films !
            </p>
            <div className="bg-netflix-red/20 border border-netflix-red/50 rounded-lg p-4 mb-4">
              <p className="text-white font-work font-bold text-3xl mb-1">30 JOURS</p>
              <p className="text-text-secondary text-sm">pour seulement 8,40 euros</p>
            </div>
            <ul className="text-left text-sm text-text-secondary space-y-2 mb-4">
              <li>Acces illimite a 1500+ films</li>
              <li>Toutes les categories</li>
              <li>Nouveaux films chaque jour</li>
              <li>Qualite HD</li>
            </ul>
          </div>
          
          <Button
            onClick={handleSubscribe}
            className="w-full bg-netflix-red hover:bg-netflix-red-hover py-6 text-lg"
          >
            S'abonner Maintenant
          </Button>
          
          <Button
            onClick={() => { setShowModal(false); navigate('/'); }}
            variant="outline"
            className="w-full border-white/20 py-4"
          >
            Retour a l'Accueil
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};